import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import R from 'ramda';

import uniLogos from '../images/unis.jpg';
import alumniLogos from '../images/alumniWork.png';
import Image from '../Image';
import Header from '../Header';
import Container from '../Container';
import LandingHero from '../LandingHero';
import TestimonialsGrid from '../TestimonialsGrid';
import Grid from '../Grid';
import Card from '../Card';
import CourseCard from '../CourseCard';
import SectionHeader from '../SectionHeader';
import Search from '../Search';
import Footer from '../Footer';

import styles from './landing.css';
import { courses } from '../constants/courses';

const { div } = hh(h);

const alumniTestimonials = [
  {
    quote: 'The overall experience with tutors and classmates was fantastic. The atmosphere was really collaborative and I seriously learned a lot.',
    author: 'Cunhao Liu'
  },
  {
    quote: 'Didn\'t expect to get this excited about the whole coding thing, really inspiring!',
    author: 'KCL student'
  },
  {
    quote: 'I learnt much more than I thought I would, and I will definitely be using these skills in the future on my website and hopefully in the world of work too. Everyone at university should be made aware of this course!',
    author: 'KCL student'
  },
  {
    quote: 'How to make my website animated! But also the general skills it has given me I feel equipped for anything!',
    author: 'Erin Kirker, LSE'
  },
  {
    quote: 'I wasn\'t really looking forward to the course because I’m completely rubbish with technology. I thought the course would be boring and long. However, I thoroughly enjoyed the weekend. I feel more confident with my computer and I like that I can write code and I will definitely do this in my own time.',
    author: 'UCL student'
  }
];

const Landing = (props) => {
    const cardProps = [
        {
            headerText: 'Don’t study computer science?',
            bodyText: 'Perfect - our courses are designed specifically for complete beginners and most of our teachers didn’t study Computer Science.',
            theme: 'four'
        },
        {
            headerText: 'Too busy studying to learn programming?',
            bodyText: 'We get it - university is tough. That’s why we design our courses to be short, intensive and with excellent student:teacher ratios so that you make huge progress in the valuable free time you have.',
            theme: 'four'
        },
        {
            headerText: 'Worried you won’t get it?',
            bodyText: 'You will - our expert teachers break every concept down to be as simple as possible and help you whenever you’re stuck. We’ve taught thousands of university students across all disciplines - from Architecture to Zoology.',
            theme: 'four'
        }
    ];

    const youCanDoItCards = cardProps.map((props, index) => h(Card, {key: index, ...props}));

    const courseCards = R.map((course) => h(CourseCard, course), courses);

    const LandingSearch = graphql(gql`
    query{
        courses(where: { published: true }) {
            id
            name
            description
            level
            startDate
            endDate
            state
            tbd
            type

            university {
              name
              shortName
            }
        }
    }
`)(Search);

    return (
        div({className: styles.landing}, [
            h(Header),
            h(Container, {size: 'big', theme: 'one', className: styles.landingHeader}, [
                h(LandingHero)]),
            h(Container, {size: 'small'}, [
                div({className: styles.uniLogoContainer}, [
                  h(Image, {src: uniLogos, alt: 'University logos', figureClasses: [styles.uniLogos]})])]),
            h(Container, {size: 'small'}, [
                h(SectionHeader, 'Find A Course At Your University'),
                h(LandingSearch, {placeholder: 'e.g. London School of Economics'})]),
            h(Container, {size: 'big', theme: 'white'}, [
                h(SectionHeader, 'Our courses'),
                h(Grid, {classNames: [styles.courseCardsGrid]}, courseCards)]),
            h(Container, {size: 'big', theme: 'neutral'}, [
                h(SectionHeader, 'What our alumni say'),
                h(TestimonialsGrid, {
                  testimonials: alumniTestimonials
                }),
                h(SectionHeader, 'Our alumni work for'),
                h(Image, {  src: alumniLogos, figureClasses: [styles.alumniLogos]})
            ]),
            h(Container, {size: 'big', theme: 'white'}, [
                h(SectionHeader, 'You can do it!'),
                h(Grid,
                  youCanDoItCards)]),
            h(Container, [
                h(Footer)])
        ])
    );
};

export default Landing;



/** WEBPACK FOOTER **
 ** ./src/Landing/index.js
 **/